/** Build-time fallback for the platform identity. Runtime values come from the API. */

export const DEFAULT_PLATFORM_BRAND = Object.freeze({
  name: process.env.REACT_APP_PLATFORM_BRAND_NAME || 'Happen',
  posName: process.env.REACT_APP_PLATFORM_BRAND_POS_NAME || 'Happen POS',
  kitchenName: process.env.REACT_APP_PLATFORM_BRAND_KITCHEN_NAME || 'Happen Kitchen',
  tagline: process.env.REACT_APP_PLATFORM_BRAND_TAGLINE || 'Good food brings people together.',
  websiteUrl: process.env.REACT_APP_PLATFORM_BRAND_WEBSITE_URL || 'https://supu.io',
  appUrl: process.env.REACT_APP_PLATFORM_BRAND_APP_URL || '',
  customerAppUrl: process.env.REACT_APP_CUSTOMER_APP_URL || 'https://app.tryhappen.com',
  supportEmail: process.env.REACT_APP_PLATFORM_BRAND_SUPPORT_EMAIL || 'support@supu.app',
  logoUrl: process.env.REACT_APP_PLATFORM_BRAND_LOGO_URL || '',
  lightLogoUrl: process.env.REACT_APP_PLATFORM_BRAND_LIGHT_LOGO_URL || '',
});
